<script setup lang="ts">
import { UPSELL_FACET_VALUE_ID } from '@layers/common/app/constants/sort'

const { t } = useI18n()

const total = ref(0)
const isLoading = ref(false)

onMounted(() => {
  window.scrollTo(0, 0)
})

const title = computed(() => t('layouts.title', [t('page.top_for_less.label')]))

useSeoMeta({
  title,
  ogTitle: title,
})
</script>

<template>
  <div class="from-error-500 via-error-600 to-error-700 relative mb10 h-56 w-full overflow-hidden bg-gradient-to-br lg:h-80 md:h-64" style="background: linear-gradient(to bottom right, #d31c23, #b91c1c, #991b1b);">
    <div class="from-error-400/20 via-error-500/15 via-error-600/15 to-error-700/10 absolute inset-0 animate-pulse bg-gradient-to-br" />

    <div class="to-error-600/10 absolute inset-0 animate-bounce from-white/10 via-transparent bg-gradient-radial" style="animation-duration: 8s;" />

    <div class="absolute inset-0 bg-white/5 backdrop-blur-sm" />

    <div class="pointer-events-none absolute inset-0">
      <div class="absolute left-[15%] top-[20%] h-8 w-8 animate-bounce border border-white/10 rounded-full bg-white/8 backdrop-blur-sm duration-6000" style="animation-duration: 6s; animation-delay: 0s;" />
      <div class="absolute left-[85%] top-[30%] h-9 w-9 animate-bounce border border-white/15 rounded-full bg-white/8 backdrop-blur-sm duration-6s delay-1.5s" style="animation-duration: 6s; animation-delay: 1.5s;" />
      <div class="absolute left-[70%] top-[60%] h-10 w-10 animate-bounce border border-white/15 rounded-full bg-white/8 backdrop-blur-sm duration-6000 delay-3000" style="animation-duration: 6s; animation-delay: 3s;" />
      <div class="absolute left-[25%] top-[70%] h-18 w-18 animate-bounce border border-white/15 rounded-full bg-white/8 backdrop-blur-sm duration-4000 delay-4500" style="animation-duration: 6s; animation-delay: 4.5s;" />
    </div>

    <div class="relative z-10 h-full flex flex-col items-center justify-center px-4 text-center md:px-6">
      <div class="mb-2 flex flex-col from-white via-red-100 via-red-200 to-red-300 bg-gradient-to-br bg-clip-text text-4xl text-transparent font-black leading-none tracking-tight drop-shadow-lg lg:text-6xl md:text-5xl" style="animation-duration: 6s;">
        <span class="uppercase">
          {{ t('page.top_for_less.buy_more') }}
        </span>
        <span class="text-xl lg:text-5xl md:text-4xl">
          {{ t('page.top_for_less.for_less') }}
        </span>
      </div>

      <p class="mb-4 max-w-2xl text-sm text-white/75 font-light leading-relaxed lg:text-lg md:text-base">
        {{ t('page.top_for_less.products_for_best_price') }}
      </p>
    </div>
  </div>

  <div class="mx-auto max-w-3xl px-2 pb-8 lg:max-w-[88rem] md:max-w-4xl lg:px-6 sm:px-4 sm:pb-12">
    <div class="mb-4">
      <ProductsGrid
        :search="{
          facetValueFilters: [{ and: UPSELL_FACET_VALUE_ID, byProduct: true }],
          sort: { price: 'ASC' },
        }"
        @total="(v) => (total = v)"
        @loading="(loading) => (isLoading = loading)"
      />
    </div>
  </div>
</template>
